/*       */

import { gql } from '@apollo/client';

export default gql`
    query printTemplatesAutocompleteQuery($startIndex: Int, $stopIndex: Int, $filterBy: [JSON], $orderBy: [JSON], $excludeBy: [JSON]) {
        count: count(dataType: "print-template", filterBy: $filterBy, excludeBy: $excludeBy)
        records: printTemplates(startIndex: $startIndex, stopIndex: $stopIndex, filterBy: $filterBy, orderBy: $orderBy, excludeBy: $excludeBy) {
            id
            name
        }
    }
`;
